import React from 'react'
import "./Turntable_banner.css"

function Turntable_banner() {
  return (
<>
<section className='Turntable_banner'>
    <div className='img_holder'>
        <img src="/assets/images/turntable_spin_wheel/Turntable_banner/banner.png" alt="banner" className='banner_img'/>
    </div>
</section>
</>
  )
}

export default Turntable_banner